import { Alert, FormControl, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import { Form, Formik, useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../redux/state/CountriesAction";
import * as modalActions from "../modalActionTypes";
import { addCountrySchema } from "../schema";
import { useNavigate } from "react-router-dom";
import { getErrorMessage } from "common/utils/Helper";

export default function FormUpdateCountry({ setOpen, countryId, setCountryId, setAction }) {
  const dispatch = useDispatch();

  const [errorSB, setErrorSB] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const openErrorSB = () => setErrorSB(true);
  const closeErrorSB = () => setErrorSB(false);

  useEffect(() => {
    dispatch(actions.editCountry(countryId));
  }, []);

  const country = useSelector((state) => state?.countries?.country);

  const closeModal = () => {
    setAction(modalActions.ADD);
    setCountryId("");
    setOpen(false);
  };

  const onSubmit = (values) => {
    const request = {
      payload: values,
      successCallBack: (response) => {
        closeErrorSB();
        dispatch(actions.getCountries());
        closeModal();
        console.log("response", response);
      },
      failCallBack: (error) => {
        console.log("error", error);
        setErrorMessage(getErrorMessage(error));
        openErrorSB();
      },
    };
    dispatch(actions.updateCountry(request));
    // alert(JSON.stringify(values, null, 2));
  };
  const handleClose = () => {
    setOpen(false);
  };
  // const navigate = useNavigate();
  const { handleSubmit, errors, values, handleChange, touched } = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: country?.id,
      name: country?.name,
    },
    validationSchema: addCountrySchema,
    onSubmit,
  });
  return (
    <MDBox m={1}>
      {errorSB && <Alert severity="error">{errorMessage}</Alert>}
      <form onSubmit={handleSubmit}>
        {/* {country?.name} */}
        <MDBox py={2}>
          <FormControl fullWidth>
            <MDInput
              id="name"
              label="Nom du pays"
              error={errors.name ? true : false}
              onChange={handleChange}
              value={values.name ?? ""}
              helperText={errors?.name ?? ""}
            />
            {/* {errors.name && touched.name ? <div>{errors.name}</div> : null} */}
          </FormControl>
        </MDBox>

        <MDBox sx={{ display: "flex" }}>
          <MDBox mr={1} sx={{ flexGrow: "1" }}>
            <MDButton onClick={handleClose} type="submit" color="primary" fullWidth>
              Annuler
            </MDButton>
          </MDBox>
          <MDBox sx={{ flexGrow: "1" }}>
            <MDButton type="submit" color="info" fullWidth>
              Modifier
            </MDButton>
          </MDBox>
        </MDBox>
      </form>
    </MDBox>
  );
}
